
export default {
    "title": "Lab",
    "entityName": "lab",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "name",
        "descending": false
    },
    filterStorage: {},
    "fields": [
        {
            full:true,
            "value": "name",
            "text": "Name",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            small:true,
            "value": "code",
            "text": "Code",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },

        {
            semisemifull:true,
            "value": "country_code",
            "text": "Country",
            "title": "name",
            "id": "code",
            "type": "autocomplete",
            // "readonly": item => { return item.id ? true : false },
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
            ],
            render: (item) => {
                return item.country.name + " (" + item.country.code + ")" 
            },
        },

       

        // {
        //     "value": "country_code",
        //     "type": "hidden",
        // },


        {
            full:true,
            "value": "address",
            "text": "Address",
            "type": "text",
            "validators": [
                "required"
            ],
        },

        {
            "small":true,
            "value": "prov",
            "text": "Prov",
            "type": "text",
            "validators": [
                "required"
            ],
        },

        {
            "small":true,
            "value": "city",
            "text": "City",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ],
        },

        {
            "small":true,
            "value": "cap",
            "text": "Postal code",
            "type": "text",
            "validators": [
                "required"
            ],
        },

        {
            "value": "lat",
            "text": "Latitude",
            "type": "text",
        },

        {
            "value": "lon",
            "text": "Longitude",
            "type": "text",
        },

        {
            "full":true,
            "value": "comment",
            "text": "Comment",
            "type": "textarea",
        },

        {
            "value": "lab_contact",
            "text": "Lab contact",
            "type": "text",
        },

        {
            "value": "email",
            "text": "Email",
            "type": "text",
        },


    ],
    "actions": [
        "upsert", "remove", "audit_trail"
    ]
}